import React from 'react';
import PropTypes from 'prop-types';
import SearchInput from 'src/components/common/SearchInput';

// Search row — wired into the candidates-list API's own `search` query
// param (see AssignmentPipeline.jsx's debounced searchQuery/useCandidatesByStatusForTa
// wiring) now that there's a real search to back it. Built on the app's
// shared SearchInput (src/components/common/SearchInput.jsx) rather than a
// hand-rolled icon+input pair — same component Opportunities.jsx and
// similar listing pages already use, so the focus ring/clear button/sizing
// all match the rest of the app instead of drifting from it (a hand-rolled
// plain <input> here had fallen back to the browser's own default focus
// outline, which read far heavier than this app's usual 3px/8%-opacity
// ring). This component itself stays a plain controlled wrapper with no
// debounce logic of its own — that lives in AssignmentPipeline.jsx, same
// division of responsibility UpcomingInterviews.jsx uses for its own search
// box. The sort control that used to sit alongside it was removed entirely
// per explicit request — it was a plain, permanently-disabled non-button
// with no real sort behind it, not a working control someone could toggle
// off.
const PipelineSearchSortBar = ({
  searchPlaceholder,
  searchValue,
  onSearchChange,
  children,
}) => (
  <div className="flex items-center gap-2 px-4 border-l border-r border-border bg-card !mt-0 py-4">
    <SearchInput
      value={searchValue}
      onValueChange={onSearchChange}
      placeholder={searchPlaceholder}
      className="flex-1"
      inputClassName="h-10 text-sm"
    />
    {children}
  </div>
);

PipelineSearchSortBar.propTypes = {
  searchPlaceholder: PropTypes.string,
  searchValue: PropTypes.string,
  onSearchChange: PropTypes.func,
  // Extra controls (e.g. SubStatusFilter) rendered in the same row, sharing
  // this bar's bg-background band instead of sitting outside it.
  children: PropTypes.node,
};

PipelineSearchSortBar.defaultProps = {
  searchPlaceholder: 'Search name, skill or employer',
  searchValue: '',
  onSearchChange: () => {},
  children: null,
};

export default PipelineSearchSortBar;
